import React from 'react';
import I18n from 'lib/i18n/i18n';
import WorthyApi from 'lib/api/worthyApi';

import UserActions from "lib/userActions";
import {googleApiKey} from "../../helpers/ApplicationHelper";
import ListingGoogleMapItem from "./listingGoogleMapItem";

class ListingGoogleMap extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            locs: []
        }


        this.getAddressFromGoogle(props.locations)
    }

    getAddressFromGoogle(locations) {
        if (!locations) return;

        locations.forEach((loc) => {
            let locs = this.state.locs;
            WorthyApi.getAddressFromGoogle(loc.address).then(results => {
                let address = results.data.results[0];
                locs.push({address});
                this.setState({locs})

            });
        })
    }
    render() {
        const {
            locs
        } = this.state;

        if(locs.length > 1) {
            return (
                <div className='listing-maps-container'>
                    {
                        locs.map((loc, idx) => {
                            return (<ListingGoogleMapItem key={idx} address={loc.address}/>)
                        })
                    }
                </div>
            )
        } else {
            return null
        }

    }
}

export default ListingGoogleMap;
